export const darkTheme = {
    name: 'dark',
    options: [
        [
            '--font-family',
            "Akkurat, 'Noto Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        ],
        ['--size-body', '13px'],
        ['--size-sub-heading', '16px'],
        ['--size-heading', '28px'],
        ['--size-label', '11px'],
        ['--black', '#000000'],
        ['--white', '#ffffff'],
        ['--red', '#d6002a'],
        ['--red-1', '#b60023'],
        ['--red-1', '#9d0725'],
        ['--dark-grey-1', '#171417'],
        ['--dark-grey-2', '#1d1a1d'],
        ['--med-grey-1', '#313131'],
        ['--med-grey-2', '#282528'],
        ['--light-grey-1', '#434143'],
        ['--light-grey-2', '#777779'],
        ['--blue-1', '#2f9ac5'],
        ['--blue-2', '#247494'],
        ['--blue-3', '#174d63'],
        ['--blue-4', '#0c2631'],
        ['--yellow', '#edf86f'],
        ['--purple', '#9a4bcd'],
        ['--base-shadow', '0 0 20px 0 rgba(0,0,0,0.2)'],
        ['--z-modal', '9000'],
        ['--z-overlay', '8000'],
        ['--z-dropdown', '7000'],
        ['--z-header', '6000'],
        ['--z-footer', '5000'],
    ],
};
export const lightTheme = {
    name: 'light',
    options: [
        [
            '--font-family',
            "Akkurat, 'Noto Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        ],
        ['--size-body', '13px'],
        ['--size-sub-heading', '16px'],
        ['--size-heading', '28px'],
        ['--size-label', '11px'],
        ['--black', '#ffffff'],
        ['--white', '#000000'],
        ['--red', '#d6002a'],
        ['--red-1', '#b60023'],
        ['--red-1', '#9d0725'],
        ['--dark-grey-1', '#fff'],
        ['--dark-grey-2', '#F5F5F5'],
        ['--med-grey-1', '#cecece'],
        ['--med-grey-2', '#E6E6E6'],
        ['--light-grey-1', '#BABABA'],
        ['--light-grey-2', '#777779'],
        ['--blue-1', '#2f9ac5'],
        ['--blue-2', '#247494'],
        ['--blue-3', '#174d63'],
        ['--blue-4', '#0c2631'],
        ['--yellow', '#edf86f'],
        ['--purple', '#9a4bcd'],
        ['--base-shadow', '0 0 20px 0 rgba(0,0,0,0.2)'],
        ['--z-modal', '9000'],
        ['--z-overlay', '8000'],
        ['--z-dropdown', '7000'],
        ['--z-header', '6000'],
        ['--z-footer', '5000'],
    ],
};
//# sourceMappingURL=index.js.map